import { useFormikContext } from 'formik';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { type FormValues } from '../types';

interface MoreFiltersModalFooterProps {
  onCancel: () => void;
  onConfirm: (values: FormValues) => void;
}

export const MoreFiltersModalFooter = ({
  onCancel,
  onConfirm,
}: MoreFiltersModalFooterProps) => {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  const handleOnSearchUserClick = () => {
    onConfirm(values);
  };

  const handleOnCancel = () => {
    // reset formik values except location and who
    setFieldValue('query', {
      address: values.query.address,
      who: values.query.who,
    });
    onCancel();
  };

  return (
    <Box>
      <Button variant="secondary" onClick={handleOnCancel}>
        {__('Cancel')}
      </Button>
      <Button ml={2} type="submit" onClick={handleOnSearchUserClick}>
        {__('Search users')}
      </Button>
    </Box>
  );
};
